import { Injectable } from '@angular/core';
import { omit } from 'lodash';
import { BehaviorSubject } from 'rxjs';
import {
    IDatiqRuleServiceMap,
    IDatiqRulesServiceEvaluator,
} from '@dat/datiq-core/models';

@Injectable({
    providedIn: 'root',
})
export class DatiqRulesRegisterService {
    private _ruleEvaluators: BehaviorSubject<IDatiqRuleServiceMap> =
        new BehaviorSubject<IDatiqRuleServiceMap>({});

    constructor() {}

    register(type: string, service: IDatiqRulesServiceEvaluator): void {
        const evaluators: IDatiqRuleServiceMap = this.getRules();

        this._ruleEvaluators.next({
            ...evaluators,
            [type]: service,
        });
    }

    getEvaluator(type: string): IDatiqRulesServiceEvaluator {
        const evaluators: IDatiqRuleServiceMap = this.getRules();

        return evaluators[type];
    }

    unregister(type: string): void {
        const evaluators: IDatiqRuleServiceMap = this.getRules();

        this._ruleEvaluators.next(omit(evaluators, [type]));
    }

    getRules(): IDatiqRuleServiceMap {
        return { ...this._ruleEvaluators.getValue() };
    }
}
